
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/api/container",
      function () {
        return require("private-next-pages/system/api/container.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/api/container"])
      });
    }
  